<!--新用户引导图片  view:13-->
<template>
    <div class="view13Wrapper shadowRadius">
        <div class="guideImage">
        <img :src="list.imgUrl" alt="" class="imgBox">
        </div>
    </div>
</template>

<script>
    export default {
        name: "View13",
        components: {},
        props: {

            tips: {
                type: String,
                default: ""
            },
            list: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {

            };

        },
        methods: {},

    };
</script>
<style lang="less" scoped>
    .view13Wrapper {

        background: rgba(255, 255, 255, 1);
        /*padding: .30rem .5rem;*/
        overflow: hidden;

        .guideImage{
            width: 100%;
            .imgBox{
                width: 100%;
                max-width: 100%;
                height: 100%;
            }
        }


    }

</style>
